import { render, staticRenderFns } from "./GroupContactsCountBadge.vue?vue&type=template&id=a9803e8a"
import script from "./GroupContactsCountBadge.vue?vue&type=script&lang=js"
export * from "./GroupContactsCountBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports